import { render, staticRenderFns } from "./FleetTable.vue?vue&type=template&id=e72b12c0&scoped=true&"
import script from "./FleetTable.vue?vue&type=script&lang=js&"
export * from "./FleetTable.vue?vue&type=script&lang=js&"
import style0 from "./FleetTable.vue?vue&type=style&index=0&id=e72b12c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72b12c0",
  null
  
)

export default component.exports